/* Certification marks: scroll only when they genuinely do not fit.
 *
 * The alternative was letting them wrap or shrink. Shrinking distorts a
 * certification mark, which is not ours to do, and a plate that silently wraps
 * to four rows in the footer looks broken — so the row stays one line and
 * moves instead, but only when it has to. A set that fits sits still.
 *
 * Measured against the FIRST set only: the duplicate exists purely to make the
 * loop seamless, so counting it would report an overflow on every plate. */
(function () {
  var SETTLE = 150;

  function firstSetWidth(track) {
    var marks = track.querySelectorAll('.cert-mark:not(.cert-mark--dupe)');
    if (!marks.length) return 0;
    var style = getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    var total = 0;
    for (var i = 0; i < marks.length; i++) total += marks[i].getBoundingClientRect().width;
    return total + gap * (marks.length - 1);
  }

  function measure(plate) {
    var track = plate.querySelector('.cert-plate-track');
    if (!track) return;
    // Measure at rest, so a plate already scrolling is not measured mid-animation.
    plate.classList.remove('is-scrolling');
    var available = plate.clientWidth - (parseFloat(getComputedStyle(plate).paddingLeft) + parseFloat(getComputedStyle(plate).paddingRight));
    if (firstSetWidth(track) > available + 1) plate.classList.add('is-scrolling');
  }

  function measureAll() {
    var plates = document.querySelectorAll('[data-cert-marks]');
    for (var i = 0; i < plates.length; i++) measure(plates[i]);
  }

  function ready() {
    measureAll();
    startCycles();
    // Late webfonts and lazy images change the width after first paint.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureAll);
    var imgs = document.querySelectorAll('.cert-mark');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) imgs[i].addEventListener('load', measureAll, { once: true });
    }
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(measureAll, SETTLE);
    });
    // The theme editor re-renders a section without reloading the page.
    document.addEventListener('shopify:section:load', function () {
      measureAll();
      startCycles();
    });
  }

  /* The cycling slot. A timer, not a CSS animation: the keyframe percentages
   * for "visible for 1/n of the cycle" depend on n, and n is however many marks
   * the snippet lists — so a static @keyframes would silently be wrong the day
   * someone adds an eighth. */
  function startCycles() {
    var slots = document.querySelectorAll('[data-cert-cycle]');
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (var i = 0; i < slots.length; i++) {
      (function (slot) {
        var marks = slot.querySelectorAll('.cert-mark');
        if (marks.length < 2 || slot.dataset.cycling === '1') return;
        slot.dataset.cycling = '1';
        slot.classList.add('is-cycling');
        marks[0].classList.add('is-on');
        // Reduced motion: show the first and never move.
        if (still) return;
        var at = 0;
        var every = parseInt(slot.dataset.every, 10) || 2200;
        var timer = null;
        function step() {
          marks[at].classList.remove('is-on');
          at = (at + 1) % marks.length;
          marks[at].classList.add('is-on');
        }
        function run() { if (!timer) timer = setInterval(step, every); }
        function halt() { if (timer) { clearInterval(timer); timer = null; } }
        // Don't burn a timer on a slot nobody is looking at.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries[0].isIntersecting ? run() : halt();
          }).observe(slot);
        } else {
          run();
        }
        document.addEventListener('visibilitychange', function () {
          document.hidden ? halt() : run();
        });
      })(slots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
